import React, { useState } from "react";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { TbSettingsCog } from "react-icons/tb";
import InputField from "../inputField/InputField";
import PasswordInput from "../inputField/PasswordInput";
import CustomSelector from "../selector/CustomSelector";

function CreditMonitoring() {
  const [activeStep, setActiveStep] = useState(1);
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlepassChange = (event) => {
    setPass(event.target.value);
  };

  const options = [
    { value: "24h", label: "24 Hours" },
    { value: "7d", label: "7 Days" },
    { value: "30d", label: "30 Days" },
    { value: "1y", label: "1 Year" },
    { value: "all", label: "All Time" },
  ];

  const handleSelectChange = (option) => {
    console.log(option);
  };

  return (
    <div className="my_account c_monitoring">
      <div className="tabs_area">
        <div className="steps">
          <button
            className={`step ${activeStep === 1 ? "active" : ""}`}
            onClick={() => setActiveStep(1)}
            disabled={false}
            aria-label="Step 1: Documents"
          >
            <TbSettingsCog className="icons" /> Credit Monitoring
          </button>
        </div>
        <div className="step-container">
          <div className="step-content">
            {activeStep === 1 && (
              <>
                <div className="tabs_card">
                  <div className="header">
                    <h4>Credit Monitoring Details</h4>
                    <HiOutlinePencilSquare className="icons" />
                  </div>
                  <div className="content">
                    <div className="text-center">
                      <h2>Enter Monitoring Login Details</h2>
                      <p className="mt-2">
                        After entering the login & password, your import will
                        begin and the login details will be auto-saved to the
                        account tab
                      </p>
                    </div>
                    <form action="" className="input_group">
                      <div className="selector">
                        <label htmlFor="">Monitoring Agency</label>
                        <CustomSelector
                          options={options}
                          onSelect={handleSelectChange}
                          selectedText="Smart Credit"
                        />
                      </div>
                      <InputField
                        label="Email"
                        value={name}
                        onChange={handleNameChange}
                        placeholder="name@example.com"
                      />
                      <PasswordInput
                        label="Password"
                        value={pass}
                        onChange={handlepassChange}
                        placeholder="password"
                      />
                      <button className="btn mt-4">Import Credit Report</button>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditMonitoring;
